import { render, staticRenderFns } from "./Leaflet.vue?vue&type=template&id=222ed546&"
import script from "./Leaflet.vue?vue&type=script&lang=js&"
export * from "./Leaflet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports